import pic1 from "../images/comapny/icon_engineering.png";
import pic2 from "../images/comapny/icon_banking.png";
import pic3 from "../images/comapny/icon_gov.png";
import pic4 from "../images/comapny/icon_teaching.png";
import pic5 from "../images/comapny/icon_technology.png";
import pic6 from "../images/comapny/icon_railway.png";
import pic7 from "../images/comapny/icon_defence.png";
import pic8 from "../images/comapny/icon_gov.png";
import pic9 from "../images/comapny/icon_acc.png";
import pic10 from "../images/comapny/icon_gpsc.png";
import pic11 from "../images/comapny/icon_police.png";
import pic12 from "../images/comapny/icon_upsc.png";
import pic13 from "../images/comapny/icon_hr.png";
import pic14 from "../images/comapny/icon_sales.png";
import pic15 from "../images/comapny/icon_marketing.png";
import pic16 from "../images/comapny/icon_finance.png";
import pic17 from "../images/comapny/icon_operations.png";
import pic18 from "../images/comapny/icon_customer_service.png";
import pic19 from "../images/comapny/icon_embedded.png";
import pic20 from "../images/comapny/icon_ai_ml.png";

export const truncate = (str, maxLength) => {
  if (str.length <= maxLength) return str;
  return str.slice(0, maxLength) + "...";
};

export const categoryImages = {
  1: pic1,
  2: pic2,
  3: pic3,
  4: pic4,
  5: pic5,
  6: pic6,
  7: pic7,
  8: pic8,
  9: pic9,
  10: pic10,
  11: pic11,
  12: pic12,
  13: pic13,
  14: pic14,
  15: pic15,
  16: pic16,
  17: pic17,
  18: pic18,
  19: pic19,
  20: pic20,
};

export const styles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    padding: "5px",
    borderRadius: "1rem",
    minHeight: "3.5rem",
  }),
  menuList: (baseStyles) => ({
    ...baseStyles,
    padding: "10px",
  }),
  menu: (baseStyles) => ({
    ...baseStyles,
    zIndex: "1000",
    borderRadius: "1rem",
  }),
  multiValue: (baseStyles) => ({
    ...baseStyles,
    padding: "0px 10px",
    borderRadius: "1rem",
  }),
};

export const getSalaryLPA = (salary) => {
  if (!salary) return "Industry Standard";

  const num = Number(salary);
  if (isNaN(num)) return salary;

  const lpa = num / 100000;

  return `${lpa % 1 === 0 ? lpa.toFixed(0) : lpa.toFixed(1)}`;
};

export const CampusDriveStatus = {
  LIVE: "live",
  HOLD: "hold",
  CANCELLED: "cancelled",
  DRAFT: "draft",
  CLOSED: "closed",
};
